import { Item } from 'fc-ui-components';
import { connectionStatuses, dataQualityLevels, mainCategories, PriceLevel, products } from 'services/brands.service';

export enum BrandAccessRight {
    MarketingMaterial = 'marketingMaterial',
    ProductData = 'productData',
    EndlessAisle = 'endlessAisle',
    ReorderPlatform = 'reorderPlatform',
    PreorderPlatform = 'preorderPlatform',
    ContentPlatform = 'contentPlatform'
}

export const accessRightsToProductPageMapping = {
    [BrandAccessRight.ProductData]: '/platform/content/products',
    [BrandAccessRight.MarketingMaterial]: '/platform/content/files',
    [BrandAccessRight.ReorderPlatform]: '/platform/reorder/brand-overview',
    [BrandAccessRight.EndlessAisle]: '/platform/clara/users',
    [BrandAccessRight.PreorderPlatform]: '/platform/preorder/search'
};

export const accessRightsToProductPageMapper = (brandId) => ({
    [BrandAccessRight.ProductData]: `/platform/content/products/${brandId}`,
    [BrandAccessRight.MarketingMaterial]: `/platform/content/files/${brandId}`,
    [BrandAccessRight.ReorderPlatform]: `/platform/reorder/search?brand=${brandId}`,
    [BrandAccessRight.EndlessAisle]: '/platform/clara/users',
    [BrandAccessRight.PreorderPlatform]: '/platform/preorder/search'
});

export enum ParticipatesInProductFlag {
    OrderPlatform = 'showReorder',
    PreorderPlatform = 'showPreorder',
    EndlessAisle = 'showEndlessAisle'
}

export const FcProductPdfLinkTranslationsMap = {
    [BrandAccessRight.EndlessAisle]: 'REQUEST_ACCESS.TERMS_AND_CONDITIONS.LINK_TEXT.ENDLESS_AISLE',
    [BrandAccessRight.ReorderPlatform]: 'REQUEST_ACCESS.TERMS_AND_CONDITIONS.LINK_TEXT.REORDER_PLATFORM',
    [BrandAccessRight.PreorderPlatform]: 'REQUEST_ACCESS.TERMS_AND_CONDITIONS.LINK_TEXT.PREORDER_PLATFORM',
    [BrandAccessRight.ContentPlatform]: 'REQUEST_ACCESS.TERMS_AND_CONDITIONS.LINK_TEXT.CONTENT_PLATFORM'
};

export interface TermOfUseValue {
    de?: string;
    en?: string;
    countrySpecific?: {
        [key: string]: string;
    };
}

export type MainCategoriesValues = (typeof mainCategories)[number]['value'][];
export type ProductsValues = (typeof products)[number]['value'][];
export type ConnectionStatusesValues = (typeof connectionStatuses)[number]['value'][];
export type DataQualityLevelValues = (typeof dataQualityLevels)[number]['value'][];
export interface BrandAccessFilters {
    name: string;
    products: ProductsValues;
    categories?: MainCategoriesValues;
    sustainableProducts?: boolean;
    priceLevels?: PriceLevel[];
    connectionStatuses?: ConnectionStatusesValues;
    dataQualityLevels?: DataQualityLevelValues;
}

export interface TermsOfUse {
    marketing?: TermOfUseValue;
    [BrandAccessRight.EndlessAisle]?: TermOfUseValue;
    products?: TermOfUseValue;
    [BrandAccessRight.ReorderPlatform]?: TermOfUseValue;
    [BrandAccessRight.ContentPlatform]?: TermOfUseValue;
}

export const BrandAccessRightTranslationsMap = {
    [BrandAccessRight.MarketingMaterial]: 'BRAND_PANEL.MARKETING_MATERIAL',
    [BrandAccessRight.ProductData]: 'BRAND_PANEL.PRODUCT_DATA',
    [BrandAccessRight.EndlessAisle]: 'BRAND_PANEL.ENDLESS_AISLE',
    [BrandAccessRight.ReorderPlatform]: 'BRAND_PANEL.REORDER_PLATFORM',
    [BrandAccessRight.PreorderPlatform]: 'BRAND_PANEL.PREORDER_PLATFORM',
    [BrandAccessRight.ContentPlatform]: 'BRAND_PANEL.CONTENT_PLATFORM'
};

export const FcProductTermsOfUse: { [productName in BrandAccessRight]: BrandAccessRight } = {
    [BrandAccessRight.MarketingMaterial]: BrandAccessRight.ContentPlatform,
    [BrandAccessRight.ProductData]: BrandAccessRight.ContentPlatform,
    [BrandAccessRight.EndlessAisle]: BrandAccessRight.EndlessAisle,
    [BrandAccessRight.ReorderPlatform]: BrandAccessRight.ReorderPlatform,
    [BrandAccessRight.PreorderPlatform]: BrandAccessRight.PreorderPlatform,
    [BrandAccessRight.ContentPlatform]: BrandAccessRight.ContentPlatform
};

export type RequestAccessFlow = 'direct' | 'note';
export type RequestMenuItem = Item<RequestAccessFlow>;

export enum FcProductConnectionStatus {
    Connected = 'connected',
    Unconnected = 'unconnected',
    Pending = 'pending'
}

export enum FcProductSuites {
    Content = 'content',
    Landing = 'landing',
    Reorder = 'reorder',
    Preorder = 'preorder',
    AutoRestock = 'auto-restock',
    Suggestions = 'suggestions'
}

export type FcProductSuiteConnectionStatus = {
    suite: FcProductSuites;
    status: FcProductConnectionStatus;
};
